import { gql } from '@apollo/client';

export const GET_ALL_USERS = gql`
  query GetAllUsers($uuid: ID!) {
    findAll: getAllUsers(uuid: $uuid) {
      email
      name
      picture
      uuid
      connection
      nickname
      roles {
        generalPermissions
        selectedTags
        selectedValue
        userAuth0ID
      }
    }
  }
`;

export const UPDATE_FINANCIALS = gql`
  mutation SetFinancials($data: SetUserFinancialsInput!) {
    setUserFinancials(data: $data)
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser($data: CreateUserInput!) {
    createUser(data: $data) {
      email
      name
      username
      uuid
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($uuid: ID!) {
    deleteUser(uuid: $uuid)
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($data: UpdateUserInput!) {
    updateUser(data: $data) {
      email
      name
      username
      uuid
    }
  }
`;

export const GET_USER_BY_UUID = gql`
  query GetUserByUuid($uuid: ID!, $organizationUuid: ID!) {
    getUserByUuid(uuid: $uuid, organizationUuid: $organizationUuid) {
      SSO
      connection
      connectionType
      email
      familyName
      financials
      givenName
      name
      nickname
      phoneNumber
      picture
      roles {
        generalPermissions
        selectedTags
        selectedValue
        userAuth0ID
      }
      username
      uuid
    }
  }
`;

export const GET_USER_FINANCIALS = gql`
  query GetUserByUuid($uuid: ID!, $organizationUuid: ID!) {
    getUserByUuid(uuid: $uuid, organizationUuid: $organizationUuid) {
      financials
    }
  }
`;
